// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__9zhkf","skeleton_user":"Skeleton_skeleton_user__LcZZk","img":"Skeleton_img__Pzbj-","content":"Skeleton_content__3D_uV","row":"Skeleton_row__1bWBj"};